// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1bKdN","head":"ProcedureTableInfo_head__2Zxv_"};